module.exports = __webpack_public_path__ + "static/media/tyn.487a6770.jpg";